import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { widgetEditMode, IWidgetReturnTranslatedValues, IDragFileBrowseData, checkIfFieldDisabled, dataURLtoBlob, IReturnChangesWidgetEditForm } from 'na-lib';
import { CommentsService } from 'src/app/service/comments.service';
import { SettingsService } from 'src/app/service/settings.service';
import { UploadService } from 'src/app/service/upload.service';
import { BillboardVdEditFormComponent } from '../billboard-vd-edit-form/billboard-vd-edit-form.component';
import { supportUrlStructure } from 'src/app/supportUrls';
import { urlInvalidCharactersValidator } from 'src/app/validators/formValidators.dt';

@Component({
    selector: 'app-splash-video-edit-form',
    templateUrl: './splash-video-edit-form.component.html',
    styleUrl: './splash-video-edit-form.component.css',
    standalone: false
})

export class SplashVideoEditFormComponent {
  @ViewChild('canvasElement') canvasElementRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('media') myVideo: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  
  @Input() data:widgetEditMode
  @Output() returnChanges = new EventEmitter<IReturnChangesWidgetEditForm>()
  userHasBetaWidgetRole = false
  splashVdData:any
  oldData:any
  defaultLanguage:string
  widgetNumber:any
  passId:any
  url:any
  translationModeOriginal = false
  dragFileData: IDragFileBrowseData
  splashVdEditForm!:FormGroup
  disableFilters = false
  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|(?:https?:\/\/|context:\/\/|pass:\/\/)\S+)$/;
  urlData:any
  dynamicUrl = false
  thumbnailUrl:any
  addUrl = false
  returnUrlData:string
  coverImageFile:any
  changes = false
  noUrl=false

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private uploadService: UploadService,
    private commentService: CommentsService,
    private translate:TranslateService,
    private settingsService: SettingsService
  ){ }
  
  ngOnInit():void{
    if(this.settingsService.checkIfBetaRoleAccess())
      this.userHasBetaWidgetRole = true

    this.defaultLanguage = this.data.defaultLanguage
    this.splashVdData=this.data.values
    this.oldData=this.splashVdData
    this.url=this.oldData.url
    this.passId = this.data.passId
    this.widgetNumber= this.data.widget

    if(this.data.translateMode){
      this.disableFilters = true
      let translateData = this.data.translateData
      const {fields, originalLanguageData, defaultLanguageWidgetData, valuesTranslated, selectedLanguage, values} = translateData

      if(translateData.originalLanguageData){
        this.translationModeOriginal = true
        this.dragFileData = translateData.dragFileDataOriginal
        this.initTranslateEditData( defaultLanguageWidgetData, valuesTranslated, originalLanguageData, [],selectedLanguage)
      }else{
        this.translationModeOriginal = false

        this.dragFileData = translateData.dragFileData
        this.initTranslateEditData(values,valuesTranslated, originalLanguageData, fields, selectedLanguage)
      }
    }
    else{
      this.dragFileData = {
        calledFrom: SplashVideoEditFormComponent,
        calledFromData:{
          passId: this.passId,
          widgetNumber:this.widgetNumber,
          widget: "splashVideo",
        },
        enableDragDrop: true,
        enableBrowse:true,
        enableMedia:true,
        enableEnterUrl:true,
        enableMultipleDragDrop:false,
        supportedFileTypes:['video/*'],
        supportedFileAccept:"video/*",
        maxSizeInBytes: 25 * 1024 * 1024, // 25 MB size limit
        maxAllowedSizeInBytes:undefined,
        returnSupportUrl: undefined,
        returnUrlData: undefined,
        enterUrl:false,
        returnUrlType:undefined
      }
      this.initWidgetEdit()
    }
    
  }

  initTranslateEditData(data, valuesTranslated, originalLanguageData, fields, selectedLanguage){

    let {id,filter,showMoreIndicator, url, type, copyright, title, autoPlay, autoRePlay, muted, videoControls, linkURL, size, name,altTitle } = data
   
    if(!originalLanguageData){
      url = valuesTranslated[selectedLanguage +'.'+id+'.url']
      altTitle = valuesTranslated[selectedLanguage +'.'+id+'.altTitle']
    }

    if(url)
      this.urlData = supportUrlStructure(url, this.passId, this.settingsService.contextId$)

    this.splashVdEditForm =  this.fb.group({
      id:[{value: id? id : undefined, disabled: checkIfFieldDisabled('id', fields, originalLanguageData)}],
      url: [{value:url ? url : undefined , disabled: checkIfFieldDisabled('url', fields, originalLanguageData)}],
      copyright: [{value:copyright ? copyright : undefined , disabled: checkIfFieldDisabled('copyright', fields, originalLanguageData)}],
      title: [{value:title ? title: undefined , disabled: checkIfFieldDisabled('title', fields, originalLanguageData)}],
      type: [{value:type ? type: undefined,disabled: checkIfFieldDisabled('type', fields, originalLanguageData)}],
      autoPlay: [{value:autoPlay ? autoPlay : false , disabled: checkIfFieldDisabled('autoPlay', fields, originalLanguageData)}],
      autoRePlay: [{value:autoRePlay ? autoRePlay : false  , disabled: checkIfFieldDisabled('autoRePlay', fields, originalLanguageData)}],
      muted: [{value:muted ? muted : false , disabled: checkIfFieldDisabled('muted', fields, originalLanguageData)}],
      videoControls: [{value:videoControls ? videoControls : false , disabled: checkIfFieldDisabled('videoControls', fields, originalLanguageData)}],
      linkURL: [{value:linkURL ? linkURL : undefined , disabled: checkIfFieldDisabled('linkURL', fields, originalLanguageData)}],

      size: [{value:size ? size : undefined , disabled: checkIfFieldDisabled('size', fields, originalLanguageData)}],
      name: [{value:name ? name : undefined , disabled: checkIfFieldDisabled('name', fields, originalLanguageData)}],
      filter: [{value:filter ? filter : undefined , disabled: checkIfFieldDisabled('filter', fields, originalLanguageData)}],
      showMoreIndicator: [{value:showMoreIndicator ? showMoreIndicator : undefined , disabled: checkIfFieldDisabled('showMoreIndicator', fields, originalLanguageData)}],
      altTitle: [{value:altTitle ? altTitle : undefined , disabled: checkIfFieldDisabled('altTitle', fields, originalLanguageData)}]
    })

    this.splashVdEditForm?.get("url").valueChanges.subscribe( (newurl) => {
      if(newurl?.match(/\${(.+)\}/)){
        this.dynamicUrl = true
        this.urlData = './../../assets/img/default.jpg'
      }else
        this.dynamicUrl = false
    })

    this.splashVdEditForm.valueChanges.subscribe( (values) => {
      if(!originalLanguageData){
        const { url, altTitle} = values
        this.returnChanges.emit({
          type:"splashVideo",
          form: this.splashVdEditForm,
          validForm: this.splashVdEditForm.valid,
          translations:{url, altTitle},
          saveDisabled: false
        })
      }
    })
  }

  initWidgetEdit(){
    const {id,filter, url, type, copyright, title, autoPlay, autoRePlay, muted, coverImageURL, videoControls, size, name,altTitle } = this.splashVdData
    let {showMoreIndicator} = this.splashVdData

    if( showMoreIndicator == true)
    showMoreIndicator = true

    if(showMoreIndicator == false )
    showMoreIndicator = false

    if(showMoreIndicator == undefined)
    showMoreIndicator = true

    if(url){
      this.supportUrl(url)
      this.url=url
    }

    this.splashVdEditForm = this.fb.group({
      id:[{value: id ? id : undefined, disabled:false}],
      type:[{value: type ? type : undefined, disabled:false}],
      url:[{value: url ? url : undefined, disabled:false}, [Validators.required, Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
      copyright:[{value: copyright ? copyright : undefined, disabled:false}],
      title:[{value: title ? title : undefined, disabled:false}],
      autoPlay:[{value: autoPlay ? autoPlay : false, disabled:false}],
      autoRePlay:[{value: autoRePlay ? autoRePlay : false, disabled:false}],
      muted:[{value: muted ? muted : false, disabled:false}],
      videoControls:[{value: videoControls ? videoControls : false, disabled:false}],
      size:[{value: size ? size : undefined, disabled:false}],
      name:[{value: name ? name : undefined, disabled:false}],
      filter:[{value: filter ? filter : undefined, disabled:false}],
      showMoreIndicator:[{value: showMoreIndicator, disabled:false}],
      coverImageURL:[{value: coverImageURL ? coverImageURL : undefined, disabled:false}],
      altTitle:[{value: altTitle ? altTitle : undefined, disabled:false}]
    })

    this.loadThumbnail(this.splashVdEditForm.value.coverImageURL)

    this.splashVdEditForm.get("url")!.valueChanges.subscribe(value => {
      const ctrl = this.splashVdEditForm.get("url");

      // dont resolve placeholder as url
      if (value?.match(/\${(.+)\}/)) {
        this.dynamicUrl = true;
        this.urlData = undefined;
        return;
      } else
        this.dynamicUrl = false;

      // if empty, clear preview and stop
      if (!value) {
        this.urlData = undefined;
        return;
      }

      // if form control is invalid, don't touch preview
      if (ctrl?.invalid)
        return;

      try {
        if ( value.includes('https://') || value.includes('http://') || value.includes('pass://') || value.includes('tridy://') || value.includes('context://') )
          this.urlData = supportUrlStructure(value, this.passId, this.settingsService.contextId$);
        else
          this.urlData = value;
        
      } catch (e) {
        this.urlData = undefined;
      }

      const video = document.getElementById('singleVideoSV') as HTMLVideoElement;
      video?.load();
    });

    this.splashVdEditForm.valueChanges.subscribe((value) => {
      this.returnChanges.emit({
        type:"splashVideo",
        form: this.splashVdEditForm,
        validForm: this.splashVdEditForm.valid,
        data:value,
        saveDisabled: !this.splashVdEditForm.valid || !value.url
      })
    }) 

    if(this.urlData) {
      if(!this.splashVdEditForm.value.coverImageURL){
        this.updateFrame()
      }
    }
  }


  loadThumbnail(url: string) {
    if(url){
      try{
        this.thumbnailUrl = new URL(url)
        const firebaseUrl = supportUrlStructure(url ,this.passId, this.settingsService.contextId$)
        this.thumbnailUrl=firebaseUrl
      }catch(error){
        this.thumbnailUrl = undefined
        this.commentService.addSnackBar.emit("LOADING VIDEO THUMBNAIL FAILED");
        console.error(error)
      }
    }
  }

  supportUrl(url){
    this.urlData = url
    if(url){
      try{
        if(url.includes('https://') || url.includes('http://') || url.includes('pass://') || url.includes('tridy://') || url.includes('context://')){
          const firebaseUrl = supportUrlStructure(url ,this.passId, this.settingsService.contextId$)
          this.urlData=firebaseUrl          
        }else
          this.urlData = url
      }catch(errro){}
    }
  }

  updateFrame() {
    const videoElement: HTMLVideoElement = this.myVideo.nativeElement;
    const canvas: HTMLCanvasElement = this.canvasElementRef.nativeElement;
    const context = canvas.getContext('2d');
    
    // Set canvas dimensions
    const scale = 0.8;
    canvas.width = Math.floor(videoElement.videoWidth * scale);
    canvas.height = Math.floor(videoElement.videoHeight * scale);
    
    // Draw
    context?.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
    // Convert
    const imageUrl = canvas.toDataURL('image/jpeg', 0.8);

    // Convert to blob
    const blob = dataURLtoBlob(imageUrl);
    // Create file
    const jpegBlob = new Blob([blob], { type: 'image/jpeg' });
    let videoName =  this.splashVdEditForm.get('url')?.value;
    if (videoName && videoName.length > 0) {
      if (videoName.startsWith('http://') || videoName.startsWith('https://'))
        videoName = videoName.split('/').pop();
      else
        videoName = videoName.replace('pass://', '').replace('context://Media/', '').split('.').slice(0, -1).join('.');
    }
    const imageFile = new File([jpegBlob], `${videoName}.jpg`, { type: 'image/jpeg' });

    // Store the frame
    this.coverImageFile = imageFile;
    this.uploadVideoThumbnail()
  }

  returnChangesFilters($event){
    this.splashVdEditForm.patchValue({filter: $event.newFilters})
  }

  returnChangesDragFileBrowseUI($event){
    if($event){
      const { returnSupportUrl,returnUrlData, enterUrl } = $event
      this.dragFileData = $event

      if(enterUrl){
        this.addUrl = true
        this.urlData = './../../assets/img/default.jpg'
      }else{
        this.addUrl = false
        this.urlData = undefined
      }

      if(returnUrlData){
        this.returnUrlData = returnUrlData
        this.urlData = returnUrlData
      }

      if(returnSupportUrl){
        this.url = returnSupportUrl
        this.splashVdEditForm.patchValue({ url: returnSupportUrl })
      }
    }
  }

  async uploadVideoThumbnail() {
    try {
      const uploadURL = await this.uploadService.uploadVideoCoverImage(this.passId, this.coverImageFile, this.widgetNumber);
      if (uploadURL) {
        this.changes = true
        this.splashVdEditForm.patchValue({coverImageURL: uploadURL})
        this.noUrl = false
        this.loadThumbnail(uploadURL)
      }
    } catch (error) {
      console.error(error);
      const message = this.translate.instant("SnackBarConstants.UPLOAD_IMG_FAILED");
      this.commentService.addSnackBar.emit(message);
    }
  }

  get hasAnyVideo(): boolean {
    const urlCtrlValue = this.splashVdEditForm.get('url')?.value;
    return !!(urlCtrlValue || this.urlData || this.url);
  }

  checkNewUrl(){
    this.url = this.splashVdEditForm.value.url
    this.supportUrl(this.splashVdEditForm.value.url)
  }

  delete(){
    this.url= undefined
    this.splashVdEditForm.patchValue({ url:this.url, size: undefined, altTitle:undefined })
    this.urlData=""
  }

  onVideoMetadataSplashVideo(event?: Event): void {
    try{
      const videoElement: HTMLVideoElement = this.myVideo.nativeElement;
      const width: number = videoElement.videoWidth;
      const height: number = videoElement.videoHeight;
      this.splashVdEditForm.patchValue({size : [ width, height]})    
    } catch(error){
      this.commentService.progressSpin.emit(false)
    }
  }
}
